<template>
  <div>
    <BrFilter v-if="false" @change="handleChange" />
    <BaseCountCardRetrospect ref="baseCountCardRetrospectRef" style="margin-top: 18px" />
    <a-row :gutter="20" style="margin-top: 20px">
      <a-col :span="12">
        <RetrospectCountUse ref="retrospectCountUseRef" />
      </a-col>
      <a-col :span="12">
        <RetrospectCountValue ref="retrospectCountValueRef" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import BrFilter from './components/BrFilter.vue';
import BaseCountCardRetrospect from './components/BaseCountCardRetrospect.vue';
import RetrospectCountUse from './components/RetrospectCountUse.vue';
import RetrospectCountValue from './components/RetrospectCountValue.vue';
import { queryBusinessRequirement, queryBrRetrospect } from '@/api/business/requirement';

export default {
  components: { BrFilter, BaseCountCardRetrospect, RetrospectCountUse, RetrospectCountValue },
  data() {
    return {
      tableData: [],
      brRetrospectMap: {},
      filterForm: {
        primaryDepartment: [],
        businessDepartment: []
      }
    };
  },
  created() {
    this.getRetData();
  },
  methods: {
    buildTableData() {
      for (let i = 0; i < this.tableData.length; i++) {
        const item = this.tableData[i];
        item.retrospectUseName = this.getRetrospectUseName(item);
        item.retrospectValueName = this.getRetrospectValueName(item);
      }

      this.$refs.baseCountCardRetrospectRef.setData(this.tableData);
      this.$refs.retrospectCountUseRef.setData(this.tableData);
      this.$refs.retrospectCountValueRef.setData(this.tableData);
    },
    handleChange(form) {
      // this.filterForm = form;
      this.getRetData();
    },
    getRetData() {
      const params = { 'searchTimeType': 1,
        'status': 0,
        'about': 'all',
        'page_size': 10000,
        'page_number': 1,
        'existsRetrospect': true
      };
      queryBusinessRequirement(params).then(res => {
        this.tableData = res.data.items || [];
        this.getBrRetrospectDatas();
      });
    },
    getBrRetrospectDatas() {
      this.brRetrospectMap = {};
      const ids = this.tableData.map(item => item.id);
      const filter = { brIdList: ids };
      queryBrRetrospect(filter)
        .then(res => {
          const _list = res.data.items || [];
          const groupedMap = {};

          _list.forEach(item => {
            if (!groupedMap[item.brId + '']) {
              groupedMap[item.brId + ''] = [];
            }
            groupedMap[item.brId + ''].push(item);
          });
          this.brRetrospectMap = groupedMap;
          console.log('this.brRetrospectMap', this.brRetrospectMap);
          this.buildTableData();
        })
        .catch(() => {
        });
    },
    getRetrospectUseName(row) {
      const text = '--';
      if (!this.brRetrospectMap) return text;
      const retrospectList = this.brRetrospectMap[row.id + ''];
      if (!retrospectList || retrospectList.length === 0) return text;
      const _list = retrospectList.filter(item => item.type === 1);
      if (!row.deliveryTime) {
        return '无交付时间';
      }

      if (!_list || _list.length === 0 || !_list[_list.length - 1].startTime) {
        // 未填写 交付时间30天内：暂未应用 否则 逾期暂未应用
        const day = (new Date().getTime() - new Date(row.deliveryTime).getTime()) / (1000 * 60 * 60 * 24);
        if (day < 30) {
          return '暂未应用';
        } else {
          return '逾期暂未应用';
        }
      } else {
        return '已应用';
      }
    },
    getRetrospectValueName(row) {
      const text = '--';
      if (!this.brRetrospectMap) return text;
      const retrospectList = this.brRetrospectMap[row.id + ''];
      if (!retrospectList || retrospectList.length === 0) return text;
      const _list = retrospectList.filter(item => item.type === 2);
      if (!row.retrospectType || row.retrospectType.length === 0 || !row.retrospectType.includes(2)) {
        return '无需追溯';
      }
      if (!row.deliveryTime) {
        return '无交付时间';
      }

      if (!_list || _list.length === 0 || _list[_list.length - 1].valueIsReach === null) {
        // 未填写
        let start = new Date().getTime();
        if (_list && _list.length > 0 && _list[_list.length - 1].valueIsReach !== null) {
          start = new Date(_list[_list.length - 1].updatedTime).getTime();
        }
        const day = (start - new Date(row.deliveryTime).getTime()) / (1000 * 60 * 60 * 24);
        if (day < 90) {
          return '暂未追溯';
        } else {
          return '逾期未追溯';
        }
      } else {
        const _data = _list[_list.length - 1];
        const day = (new Date(_data.updatedTime).getTime() - new Date(row.deliveryTime).getTime()) / (1000 * 60 * 60 * 24);
        const b = _data.valueIsReach ? '' : '不';
        if (day < 90) {
          return '已完成追溯:' + b + '符合预期';
        } else {
          return '逾期完成追溯:' + b + '符合预期';
        }
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
